import { Injectable } from "@angular/core";
import { CacheFactory, CacheStore, StorageMode } from "@obg/ngx.global";
import { Observable } from "rxjs";

import {
	CACHE_STORE_OPEN_ID_CONNECT,
	OPEN_ID_CONNECT_CPR_KEY,
	OPEN_ID_CONNECT_CURRENT_JOURNEY_KEY,
	OPEN_ID_CONNECT_LAST_ACTIVE_USER_KEY,
	OPEN_ID_CONNECT_REGISTRATION_CPR_KEY,
	OPEN_ID_CONNECT_RETURN_URL_KEY,
	OPEN_ID_CONNECT_SHOULD_REMEMBER_USER_KEY,
	OpenIdConnectProviders,
	OpenIdConnectShouldRememberUserData,
} from "./open-id-connect.const";

@Injectable({ providedIn: "root" })
export class OpenIdConnectCacheService {
	private cache: CacheStore;

	constructor(cacheFactory: CacheFactory) {
		this.cache = cacheFactory.get(CACHE_STORE_OPEN_ID_CONNECT, {
			storageMode: StorageMode.LocalStorage,
		});
	}

	setLastActiveUser(cpr: string): void {
		this.cache.setItemAsObservable(OPEN_ID_CONNECT_LAST_ACTIVE_USER_KEY, cpr);
	}

	removeLastActiveUser(): void {
		this.cache.removeItemAsObservable(OPEN_ID_CONNECT_LAST_ACTIVE_USER_KEY);
	}

	getLastActiveUser$(): Observable<string | null> {
		return this.cache.getItemAsObservable<string>(OPEN_ID_CONNECT_LAST_ACTIVE_USER_KEY);
	}

	setShouldRememberUserData(shouldRememberUserData: OpenIdConnectShouldRememberUserData): void {
		this.cache.setItemAsObservable(OPEN_ID_CONNECT_SHOULD_REMEMBER_USER_KEY, shouldRememberUserData);
	}

	getShouldRememberUserData$(): Observable<OpenIdConnectShouldRememberUserData | null> {
		return this.cache.getItemAsObservable<OpenIdConnectShouldRememberUserData>(
			OPEN_ID_CONNECT_SHOULD_REMEMBER_USER_KEY
		);
	}

	removeShouldRememberUserData(): void {
		this.cache.removeItemAsObservable(OPEN_ID_CONNECT_SHOULD_REMEMBER_USER_KEY);
	}

	setReturnUrl(route: string): void {
		this.cache.setItemAsObservable(OPEN_ID_CONNECT_RETURN_URL_KEY, route);
	}

	unsetCPR(): void {
		this.cache.removeItemAsObservable(OPEN_ID_CONNECT_CPR_KEY);
	}

	getReturnUrl$(): Observable<string | null> {
		return this.cache.getItemAsObservable<string | null>(OPEN_ID_CONNECT_RETURN_URL_KEY);
	}

	getCurrentJourney(): OpenIdConnectProviders | null {
		return sessionStorage.getItem(OPEN_ID_CONNECT_CURRENT_JOURNEY_KEY) as OpenIdConnectProviders | null;
	}

	removeCurrentJourney(): void {
		sessionStorage.removeItem(OPEN_ID_CONNECT_CURRENT_JOURNEY_KEY);
	}

	setRegistrationCpr(cpr: string): void {
		this.cache.setItemAsObservable(OPEN_ID_CONNECT_REGISTRATION_CPR_KEY, cpr);
	}

	getRegistrationCpr$(): Observable<string | null> {
		return this.cache.getItemAsObservable<string>(OPEN_ID_CONNECT_REGISTRATION_CPR_KEY);
	}

	removeRegistrationCpr(): void {
		this.cache.removeItemAsObservable(OPEN_ID_CONNECT_REGISTRATION_CPR_KEY);
	}
}
